module.exports = __webpack_public_path__ + "img/jpm.58e6c551.svg";